import { render, staticRenderFns } from "./BookingSelectList.vue?vue&type=template&id=88064fae&"
import script from "./BookingSelectList.vue?vue&type=script&lang=js&"
export * from "./BookingSelectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports